/*
 * @Author: LS
 * @Date: 2023-11-09 14:44:38
 * @LastEditTime: 2023-11-10 09:06:53
 * @LastEditors: LS
 * @Description: 城市列表组件
 */
"use client";

import { useState, useEffect,useRef } from "react";
import KeyDom from "./KeyDom";
import ListDom from "./ListDom";
import Book, { useBook } from "@/components/Book";
import { Toast } from "antd-mobile";
import { getUrlParams } from "@/utils/utils";
import { getAllCityByGroup } from "@/api/condition";
import s from "./IndexDom.module.css";
import useReport from "@/hooks/useReport";

// searchParams 里如果带着cityCode=500100&cityId=3101&cityName=重庆&citySpell=chongqing 则从url取，否则从cookie里取
// searchParams 里如果带着 callBackField=cityCode,cityName 则回调：xx?cityCode=500100&cityName=重庆 即要求返回时url强写的参数，无值则什么都不返回，只允许填写cityId,cityCode,cityName,citySpell
// searchParams 里如果带着 获取门店信息参数,此项如传值则会做标准检测+获取门店  effluentStandard=国5 //当前车源排放标准  ucarId=102158220  //车源ID
// searchParams 里如果带着 returnPath 回调的url，必填,用encodeURIComponent加密
// effluentStandard有值的时候将returnPath里的storeId替换成变量storeId
const Page = (props) => {
  const { searchParams } = props;
  const effluentStandard = searchParams?.effluentStandard;

  const [cityData, setCityData] = useState([]);
  const [isOnFocus, setIsOnFocus] = useState(false);
  const book = useBook({ defaultActive: "cg_#" });
  const [urlParams, setUrlParams] = useState({});
  const ToastRef = useRef();

  useReport(43004);

  useEffect(() => {
    if (typeof window !== "undefined") {
      setUrlParams(getUrlParams()); // 需要在页面加载完毕后获取url， 如果放到外面，获取的是之前的url地址。。。
    }
    getData();
  }, []);

  const getData = (type) => {
    ToastRef.current = Toast.show({
      icon: "loading",
      duration: 0
    });
    getAllCityByGroup({ type: effluentStandard ? 1 : type || 0 }).then(
      (res) => {
        setCityData(res.data);
        Toast.clear();
        ToastRef.current?.clear?.();
      }
    );
  };

  return (
    <div className={s.cityclass}>
      <Book book={book} className={s.book}>
        <KeyDom
          {...props}
          urlParams={urlParams}
          book={book}
          isOnFocus={isOnFocus}
          setIsOnFocus={setIsOnFocus}
          cityData={cityData}
          getData={getData}
        />
        <ListDom
          {...props}
          urlParams={urlParams}
          book={book}
          isOnFocus={isOnFocus}
          setIsOnFocus={setIsOnFocus}
          cityData={cityData}
          getData={getData}
        />
      </Book>
    </div>
  );
};
export default Page;
